import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

const ITEMS = [
  "You're tired of being broke and watching others live the life you want.",
  "You know you're capable of more but nobody around you gets it.",
  "You've tried learning from YouTube and free content — but nothing sticks.",
  "You want a step-by-step system, not random advice from people who haven't done it.",
  "You're willing to put in the work if someone shows you exactly what to do.",
  "You want to build real skills that generate income — not a certificate that collects dust.",
  "You're ready to surround yourself with winners instead of people who drag you down.",
  "You want to escape the 9-5 and build something of your own.",
];

export default function IsThisYou() {
  return (
    <section className="section-pad bg-[hsl(0_0%_4%)] relative">
      <div className="container-x">
        <div className="max-w-3xl mb-10">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">Be Honest With Yourself</div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">IS THIS YOU?</h2>
        </div>
        <div className="grid gap-3 md:grid-cols-2">
          {ITEMS.map((text, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -8 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.35, delay: i * 0.03 }}
              className="flex items-start gap-3 p-4 rounded-xl bg-[hsl(240_6%_10%)] border border-border hover:border-[rgba(245,185,66,0.35)] transition-colors"
            >
              <div className="shrink-0 h-8 w-8 rounded-lg flex items-center justify-center bg-[rgba(245,185,66,0.08)] text-[hsl(43_92%_56%)] border border-[rgba(245,185,66,0.28)]">
                <Zap className="h-4 w-4" fill="currentColor" />
              </div>
              <p className="text-[15px] leading-relaxed text-[hsl(0_0%_86%)]">{text}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-foreground max-w-2xl">
          If that's you — AlveeTrade was built for you. Not for people who want to sit around and think about it. For people who are ready to move.
        </p>
      </div>
    </section>
  );
}
